import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '@shared/Constants';
import { AuthDTO, AuthLoginDTO, AuthRegisterDTO } from '@shared/dtos';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceBackend {

  constructor(private httpClient: HttpClient) { }

  public login(auth: AuthLoginDTO): Observable<AuthDTO> {
    return this.httpClient.post<AuthDTO>(
      `${Constants.apiAuthUrl}:signInWithPassword?key=${Constants.apiKey}`, auth)
      .pipe(
        catchError(err => of(null))
      );
  }
  
  public register(auth: AuthRegisterDTO): Observable<AuthDTO> {
    return this.httpClient.post<AuthDTO>(`${Constants.apiAuthUrl}:signUp?key=${Constants.apiKey}`, auth);
  }
}
